import { collection, getDocs } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { CollaboratorPublic } from '@/features/Collaborators/Data/hooks/useCollaboratorsPublicQuery';
import { buildDpRows } from '../utils/vacationDpRows';
import { vacationBalanceService } from './vacationBalanceService';
import { vacationRequestService } from './vacationRequestService';
import type { VacationDpRow } from '../models/vacationDpBoard.types';

export const DP_ACCESS_DENIED_CODE = 'vacations/acesso-nao-liberado';

export const DP_ACCESS_DENIED_MESSAGE =
    `${DP_ACCESS_DENIED_CODE}: Seu acesso ao painel de férias ainda não foi liberado neste ` +
    'dispositivo. Saia e entre novamente para atualizar suas permissões.';

class VacationDpBoardServiceClass {
    async getBoardRows(): Promise<VacationDpRow[]> {
        try {
            const [balances, collaborators, requests] = await Promise.all([
                vacationBalanceService.listAll(),
                this.listCollaborators(),
                vacationRequestService.listAll(),
            ]);

            return buildDpRows({ balances, collaborators, requests });
        } catch (error) {
            if ((error as { code?: string }).code === 'permission-denied') {
                throw new Error(DP_ACCESS_DENIED_MESSAGE);
            }
            throw error;
        }
    }

    private async listCollaborators(): Promise<Map<string, CollaboratorPublic>> {
        const snapshot = await getDocs(collection(db, 'collaborators_public'));

        return new Map(
            snapshot.docs.map((snap) => [
                snap.id,
                { id: snap.id, ...(snap.data() as Omit<CollaboratorPublic, 'id'>) },
            ])
        );
    }
}

export const vacationDpBoardService = new VacationDpBoardServiceClass();
